import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { useLang } from '@/hooks/useLang';

export default function NotFound() {
  const { t } = useTranslation();
  const lang = useLang();

  useEffect(() => {
    document.title = '404 Not Found | AllChinaBuy Spreadsheet Hub';
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1 flex items-center justify-center">
        <div className="text-center px-4 py-20">
          <div className="w-16 h-16 mx-auto mb-6 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-400">
            <i className="ri-error-warning-line text-3xl" />
          </div>
          <h1 className="font-heading text-4xl md:text-5xl font-semibold text-foreground-900 mb-4">
            404
          </h1>
          <p className="text-lg text-foreground-600 mb-8">
            {t('common.notFoundDesc')}
          </p>
          <a
            href={`/${lang}/`}
            className="inline-flex items-center px-6 py-3 bg-primary-500 text-background-50 font-medium rounded-md hover:bg-primary-600 transition-colors"
          >
            {t('common.backToHome')}
          </a>
        </div>
      </main>
      <Footer />
    </div>
  );
}